import AboutAttributesGenes from './Genes/AboutAttributesGenes';
import AboutAttributesVariants from './Variants/AboutAttributesVariants';
import AboutAttributesDiseases from './Diseases/AboutAttributesDiseases';
import AboutAttributesChemicals from './AboutAttributesChemicals';
import AboutAttributesGeneDisease from './GeneDisease/AboutAttributesGeneDisease';
import AboutAttributesVariantDisease from './VarianDiseases/AboutAttributesVariantDisease';
import AboutAttributesDiseaseDisease from './AboutAttributesDiseaseDisease';
import References from './References/References';

function AboutAttributes() {
  return (
    <div>
      <h2>Data Attributes</h2>
      <p>
        In order to ease the interpretation and analysis of gene-disease, variant-disease associations, and
        disease-disease associations we provide the following information for the data.
      </p>
      <div className="mb-2 divider" />
      <AboutAttributesGenes />
      <div className="mb-2 divider" />
      <AboutAttributesVariants />
      <div className="mb-2 divider" />
      <AboutAttributesDiseases />
      <div className="mb-2 divider" />
      <AboutAttributesChemicals />
      <div className="mb-2 divider" />
      <References />
      <div className="mb-2 divider" />
      <AboutAttributesGeneDisease />
      <div className="mb-2 divider" />
      <AboutAttributesVariantDisease />
      <div className="mb-2 divider" />
      <AboutAttributesDiseaseDisease />
    </div>
  );
}

export default AboutAttributes;
